<template>
  <v-container>
    <date-filter v-model="selectedDate" @onSelected="getData"></date-filter>
    <v-layout wrap>
      <v-flex xs12 sm2>
        <v-select
          v-model="status"
          :items="statusOptions"
          label="Solo field"
          solo
          @change="onStatusChange"
        ></v-select>
      </v-flex>

      <v-flex xs12 sm10 class="text-xs-right">
        <v-btn outline color="primary" @click="exportOrderSummary" :loading="loading">
          <i class="fas fa-file-export mr-1"></i>
          {{$t('export')}}
        </v-btn>
      </v-flex>
    </v-layout>
    <v-layout wrap>
      <v-flex xs12 sm6 class="form-control">
        <input type="text" :placeholder="$t('Search')" v-model="search" />
      </v-flex>
      <v-flex xs12 sm6 class="text-xs-right">
        <v-pagination
          v-model="pageNumber"
          :length="pageCount"
          @input="onClickPageinate"
          class="mb-2"
        ></v-pagination>
      </v-flex>
    </v-layout>

    <template v-if="loading">
      <div class="pa-5 text-xs-center">
        <v-progress-circular indeterminate color="primary"></v-progress-circular>
      </div>
    </template>
    <template v-else>
      <v-layout>
        <v-flex>
          <v-checkbox v-model="selectedAll" :label="`${$t('Select All')}`" color="primary"></v-checkbox>
        </v-flex>
        <v-flex>
          <multiselect
            v-model="applyStatus"
            :options="['Approve', 'Reject']"
            :allow-empty="false"
            :searchable="false"
            selectLabel
            selectedLabel
            deselect-label
            class="mt-2"
            @input="onChangeStatus"
          ></multiselect>
        </v-flex>
      </v-layout>
      <template v-for="(order,index) in filterOrders">
        <order-summary-item v-model="filterOrders[index]" :key="`${index}_${order.id}`"></order-summary-item>
      </template>
    </template>

    <v-layout wrap>
      <v-flex xs12 sm2>
        <v-select
          v-model="status"
          :items="statusOptions"
          label="Solo field"
          solo
          @change="onStatusChange"
        ></v-select>
      </v-flex>
      <v-flex xs12 sm10 class="text-xs-right">
        <v-pagination
          v-model="pageNumber"
          :length="pageCount"
          @input="onClickPageinate"
          class="mb-2"
        ></v-pagination>
      </v-flex>
    </v-layout>
    <v-dialog v-model="showChangeStatus" max-width="600px" persistent>
      <v-card>
        <div class="text-xs-right">
          <v-btn small flat fab @click="onCancelApplyStatus">
            <v-icon>close</v-icon>
          </v-btn>
        </div>
        <v-card-text>
          <h3 class="headline primary--text mt-0 text-xs-center">Do you want to change all status?</h3>
          <div class="text-xs-center">
            <v-checkbox v-model="showRemark" :label="`Edit Remark`"></v-checkbox>
            <div class="form-control" v-if="showRemark">
              <textarea
                v-model="allRemark"
                style="width: 100%; min-height: 60px"
                placeholder="Remark"
              ></textarea>
            </div>

            <v-btn color="grey" outline @click="onCancelApplyStatus">{{$t('Cancel')}}</v-btn>
            <v-btn color="primary" depressed @click="onSaveApplyStatus">{{$t('Save')}}</v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import numeral from 'numeral'
import { mapGetters } from 'vuex'
import api from '@/api'
import moment from 'moment'
import DateFilter from '@/components/view/dashboard/DateFilter'
import OrderSummaryItem from './OrderSummaryItem'
import Multiselect from 'vue-multiselect'
export default {
  data() {
    return {
      applyStatus: null,
      selectedAll: false,
      statusOptions: ['All', 'Not Assign', 'Approve', 'Reject'],
      selectedDate: {
        start: moment()
          .startOf('month')
          .format('YYYY-MM-DD'),
        end: moment()
          .endOf('month')
          .format('YYYY-MM-DD')
      },
      status: 'All',
      pageNumber: 1,
      size: 10,
      orders: [],
      search: '',
      loading: false,
      showChangeStatus: false,
      showRemark: false,
      allRemark: ''
    }
  },
  components: {
    DateFilter,
    OrderSummaryItem,
    Multiselect
  },
  mounted() {
    var vm = this
    vm.loading = true
    this.getHafeleRedeemDetail().then(response => {
      vm.orders = response.data
      vm.loading = false
    })
  },
  computed: {
    pageCount: function() {
      let l = this.filterOrders.length
      let s = this.size
      return Math.ceil(l / s)
    },
    filterOrders() {
      var vm = this
      var orders = []

      if (vm.search != '') {
        orders = vm.orders.filter(function(el) {
          return (
            el.redeem_detail.toLowerCase().includes(vm.search.toLowerCase()) ||
            el.emp_first_name.toLowerCase().includes(vm.search.toLowerCase()) ||
            el.emp_last_name.toLowerCase().includes(vm.search.toLowerCase()) ||
            el.emp_id.toLowerCase().includes(vm.search.toLowerCase()) ||
            el.remark.toLowerCase().includes(vm.search.toLowerCase())
          )
        })
      } else {
        orders = vm.orders
      }

      const start = (vm.pageNumber - 1) * vm.size
      const end = start + vm.size
      return orders.slice(start, end)
    }
  },
  methods: {
    onCancelApplyStatus() {
      this.showChangeStatus = false
      this.applyStatus = null
      this.allRemark = ''
    },
    async onSaveApplyStatus() {
      var vm = this
      var orders = vm.orders.filter(el => {
        return el.selected
      })
      if (orders) {
        vm.$store.dispatch('loading')
        var promises = orders.map(async el => {
          var result = await vm.saveHafeleRedeemDetail(el.id, vm.applyStatus, vm.allRemark, false)
          var orderIndex = vm.orders.findIndex(order => {
            if (order.id == el.id) {
              console.log(order.status)
            }
            return order.id == el.id && (order.status == '' || order.status == null)
          })
          console.log(orderIndex)
          if (orderIndex != -1) {
            vm.$set(vm.orders[orderIndex], 'status', vm.applyStatus)
            vm.$set(vm.orders[orderIndex], 'remark', vm.allRemark)
          }
          return true
        })
        const test = await Promise.all(promises)
        vm.$store.dispatch('loading')
        vm.showChangeStatus = false
        vm.applyStatus = null
        vm.allRemark = ''
      }
    },
    onChangeStatus(type) {
      if (
        this.orders.find(el => {
          return el.selected == true
        })
      ) {
        this.showChangeStatus = true
      } else {
        this.applyStatus = null
      }
    },
    selectAll: function() {
      var vm = this
      vm.orders.map((el, index) => {
        vm.$set(vm.orders[index], 'selected', vm.selectedAll)
      })
    },
    select: function() {
      this.selectedAll = false
    },
    onStatusChange() {
      this.getData()
    },
    saveHafeleRedeemDetail(id, status, remark, sendremark = false) {
      var vm = this
      return new Promise((resolve, reject) => {
        var data = {
          id: id,
          status: status,
          remark: remark ? remark : '',
          sendremark: sendremark
        }
        api.saveHafeleRedeemDetail(data, function(error, response) {
          if (error) {
            console.error(error)
            reject(error)
          }

          resolve()
        })
      })
    },
    onClickPageinate: function(pageNum) {
      $('.vb-content').animate({
        scrollTop: 0
      })
    },
    getData: function() {
      var vm = this
      vm.loading = true
      this.getHafeleRedeemDetail().then(response => {
        var orders = response.data
        orders.map((el, index) => {
          orders[index].selected = false
        })
        vm.orders = orders
        vm.loading = false
      })
    },
    getHafeleRedeemDetail: function() {
      var vm = this
      return new Promise((resolve, reject) => {
        var data = {
          status: vm.status,
          datefrom: moment(vm.selectedDate.start).format('YYYY/MM/DD'),
          dateto: moment(vm.selectedDate.end).format('YYYY/MM/DD')
        }
        api.getHafeleRedeemDetail(data, function(error, response) {
          if (error) {
            reject(error)
          }
          resolve(response)
        })
      })
    },
    exportOrderSummary: function() {
      let vm = this
      let header = 'data:text/csv;charset=utf-8,%EF%BB%BF'
      let csvContent = ''
      let orders = []
      let filter = []
      vm.loading = true
      if (vm.search == '') {
        filter = vm.orders
      } else {
        filter = vm.orders.filter(function(el) {
          return el.redeem_detail.toLowerCase().includes(vm.search.toLowerCase())
        })
      }

      csvContent +=
        'emp_id,emp_first_name,emp_last_name,photourl,redeem_date,redeem_detail,redeem_point,remark,status' +
        '\r\n'
      $.each(filter, function(index, val) {
        let row =
          '="' +
          val.emp_id.replace(/\r?\n|\r/g, ' / ') +
          '","' +
          val.emp_first_name.replace(/\r?\n|\r/g, ' / ') +
          '","' +
          val.emp_last_name.replace(/\r?\n|\r/g, ' / ') +
          '","' +
          (val.photourl ? val.photourl.replace(/\r?\n|\r/g, ' / ') : '') +
          '","' +
          moment(val.redeem_date).format('DD/MM/YYYY') +
          '","' +
          (val.redeem_detail != null ? val.redeem_detail.replace(/\r?\n|\r/g, ' / ') : '') +
          '","' +
          numeral(val.redeem_point)
            .format('0,0.00')
            .toString() +
          '","' +
          (val.remark != null ? val.remark.replace(/\r?\n|\r/g, ' / ') : '') +
          '","' +
          (val.status != null ? val.status.replace(/\r?\n|\r/g, ' / ') : 'Not Assign') +
          '"'
        csvContent += row + '\r\n'
      })

      var encodedUri = header + encodeURI(csvContent)
      var link = document.createElement('a')
      link.setAttribute(
        'style',
        'overflow: hidden;position: fixed;width: 1px;height: 1px;z-index: -1;opacity: 0;'
      )
      link.setAttribute('href', encodedUri)
      link.setAttribute('download', 'order_summary_' + moment().format('YYYY_MM_DD') + '.csv')
      link.innerHTML = 'Click Here to download'
      document.body.appendChild(link) // Required for FF

      link.click()
      vm.loading = false
    }
  },
  watch: {
    selectedAll: function(newVal, oldVal) {
      var vm = this
      vm.selectAll()
    }
  }
}
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/components/view/template/hafele/OrderSummary.vue